/**
 * Item Detail Page — /prioritization/items/:itemId (and the Mandate platform's
 * items/:itemId).
 *
 * The page is ItemDetailRealPage: the third-pass item design
 * (/elevation/lab/item-detail-third-pass) rendered with the real item. The
 * earlier nine-tab page that lived here was replaced in place — one route,
 * no second URL. Old ?tab= links land in the matching destination.
 */
import { ItemDetailRealPage } from '@/features/item-detail-third-pass/ItemDetailRealPage';

export function ItemDetailPage() {
  return <ItemDetailRealPage />;
}

export default ItemDetailPage;
